<template>
<div class="map-configuration-info-wrapper">
  <div class="area event">
    <div class="title" @click="openEventPopup"> 이벤트 발생 {{ eventTotalCount }}건</div>
    <el-carousel ref="eventCarousel" height="29px" direction="vertical" :autoplay="true" arrow="never" indicator-position="none" :interval="5000">
      <el-carousel-item v-for="(eventDivide, index) in eventDivideList" :key="index">
        <el-tooltip :content="eventlevel.eventlevelName" v-for="eventlevel in eventDivide" :key="eventlevel.eventlevelId">
          <div class="list">
            <div class="event-indicator icon-dot" :style="{'background-color': eventlevel.eventlevelColorBg}"></div>
            <span class="event-indicator-span">{{eventlevel.count}}</span>
          </div>
        </el-tooltip>
      </el-carousel-item>
    </el-carousel>
  </div>
  <div class="area obj">
    <div class="title" @click="openPerfInfoPopup"> {{ objTotalCount }}개의 대상</div>
    <el-carousel ref="objCarousel" height="29px" direction="vertical" :autoplay="true" arrow="never" indicator-position="none" :interval="5000">
      <el-carousel-item v-for="(objDivide, index) in objDivideList" :key="index">
        <ul>
          <li v-for="obj in objDivide" :key="obj.objDefineId">
            <div class="text-wrapper">
              {{ obj.objDefineName }}
              <span :class="['high', 'r-title-span', (obj.objDefineId === 'UNKNOWN' ? 'unknown' : '')]">{{ obj.count }}</span>
              개
            </div>
          </li>
        </ul>
      </el-carousel-item>
    </el-carousel>
  </div>
  <w-topologymap-event-popup ref="topologymapEventPopup"></w-topologymap-event-popup>
  <w-topologymap-perf-info-popup ref="topologymapPerfInfoPopup"></w-topologymap-perf-info-popup>
</div>
</template>

<script>
import axios from 'axios';
import chunk from 'lodash/chunk';
import Base from '@/mixins/topologymap/base';
import MapAPI from '@/api/topologymap/common';
import { MapInfo } from '@/views/topologymap/js/maps';
import WTopologymapPerfInfoPopup from '@/views/topologymap/components/popup/TopologymapPerfInfoPopup';
import WTopologymapEventPopup from '@/views/topologymap/components/popup/TopologymapEventPopup';

const TASK_NAME = 'map_configuration_info';
const SLIDE_INTERVAL = 10;
export default {
  name: 'WMapConfigurationInfo',
  mixins: [Base],
  components: {
    WTopologymapPerfInfoPopup,
    WTopologymapEventPopup,
  },
  data() {
    return {
      isLoading: false,
      eventTotalCount: 0,
      eventDivideCount: 1,
      eventCountList: [],
      objTotalCount: 0,
      objDivideCount: 1,
      objCountList: [],
      cancelToken: null,
    };
  },
  mounted() {
    window.addEventListener('resize', this.updateSize);

    MapInfo.getInstance(this).addMapCompleteCallback(this.startTask);
    MapInfo.getInstance(this).addMapClearCallback(this.removeTask);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSize);

    this.removeTask();
  },
  computed: {
    eventDivideList() {
      return chunk(this.eventCountList, this.eventDivideCount);
    },
    objDivideList() {
      return chunk(this.objCountList, this.objDivideCount);
    },
  },
  methods: {
    updateSize() {
      this.$nextTick(() => {
        this.eventDivideCount = Math.floor(this.$refs.eventCarousel.$el.clientWidth / 50);
        this.objDivideCount = Math.floor(this.$refs.objCarousel.$el.clientWidth / 100);
      });
    },
    initData() {
      this.isLoading = false;
      this.eventTotalCount = 0;
      this.eventDivideCount = 1;
      this.eventCountList = [];
      this.objTotalCount = 0;
      this.objDivideCount = 1;
      this.objCountList = [];
    },
    startTask() {
      this.loadData();

      this.$taskManager.createTask(TASK_NAME, SLIDE_INTERVAL, this.loadData);
      this.$taskManager.startTask(TASK_NAME);
    },
    removeTask() {
      this.initData();
      this.cancelLoadData();

      this.$taskManager.removeTask(TASK_NAME);
    },
    cancelLoadData() {
      if (this.cancelToken) {
        this.cancelToken.cancel();
      }
    },
    loadData() {
      const mapId = this.$store.getters.getCurrentMapId;
      if (this.isLoading || this.isEditMode || mapId == null) {
        return;
      }

      this.cancelLoadData();
      this.cancelToken = axios.CancelToken.source();

      this.isLoading = true;
      MapAPI.getEventAndObjCountInMaps(mapId).then((response) => {
        if (response.data.success) {
          const result = response.data.data;

          let tmpEventTotalCount = 0;
          const tmpEventCountList = [];
          result.eventList.forEach((item) => {
            if (item.count > 0) {
              tmpEventTotalCount += item.count;
              tmpEventCountList.push(item);
            }
          });
          this.eventTotalCount = tmpEventTotalCount;
          this.eventCountList = tmpEventCountList;

          let tmpObjTotalCount = 0;
          const tmpObjCountList = [];
          result.countList.forEach((item) => {
            if (item.count > 0) {
              if (item.objDefineId !== 'UNKNOWN') {
                tmpObjTotalCount += item.count;
              }
              tmpObjCountList.push(item);
            }
          });
          this.objTotalCount = tmpObjTotalCount;
          this.objCountList = tmpObjCountList;
        }
      }).finally(() => {
        this.isLoading = false;

        this.updateSize();
      });
    },
    getCountUnit(key) { // 수정 시 src\views\performance\node\summary\service\index.vue도 영향도 파악 필요.
      if (key === 'NETINTERFACE') {
        return '포트';
      } else if (['SERVER', 'NETDEVICE', 'DBMS'].indexOf(key) >= 0) {
        return '대';
      }
      return '개';
    },
    openPerfInfoPopup() {
      this.$refs.topologymapPerfInfoPopup.open();
    },
    openEventPopup() {
      this.$refs.topologymapEventPopup.open();
    },
  },
};
</script>

<style lang="scss">
.map-configuration-info-wrapper {
  $url : '../../../../assets/img/';

  height: 45px;
  background-color: #f7f9fd;
  padding: 8px 18px;
  color: #555;

  .area {
    display: inline-block;

    &.event {
      width: calc(40% - 5px);

      .list{
        display: flex;
        float: left;
        margin-right: 10px;
        margin-top: 8px;

        .event-indicator {
          height: 9px;
          width: 9px;
          border-radius: 50%;
          margin-right: 6px;
          margin-top: 2px;
        }
        .event-indicator-span {
          cursor: default;
        }
      }
    }

    &.obj {
      width: calc(60% - 5px);

      ul {
        line-height: 29px;
      }

      li{
        margin: 0 0 0 12px;
        padding: 0 0 0 6px;
        font-weight: 400;
        font-size: 12px;
        background: url($url + 'dot_l.png') no-repeat 0 8px;
        height: 20px;
        line-height: 20px; //0402 추가
        display: inline-block;
      }
      li > .num {
        display: inline-block;
        width: 19px;
        height: 19px;
        border-radius: 4px;
        background-color: #38383a;
        color: #555;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        margin-right: 6px;
        float: left;
        // font-family:  'Open Sans', sans-serif;
      }
      .high{
        color: #0041ce;
        // font-family:  'Open Sans', sans-serif;
        font-weight: 500;
        margin-left: 2px;

        &.unknown {
          color: #333;
        }
      }
      .text-wrapper {
        cursor: default;
      }
    }

    .title {
      font-size: 13px;
      line-height: 22px;
      font-weight: 400;
      background: #3a84fd;
      color: white;
      padding: 0px 10px;
      border-radius: 4px;
      line-height: 33px;
      height: 29px;
      cursor: pointer;
      float: left;
      margin-right: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/MapConfigurationInfo.vue